import { useState } from "react";

const testimonials = [
  {
    quote: "My solar system was producing 40% less than expected. They diagnosed a failed inverter and wiring issue in one visit, fixed it the same day. Production is back to full output.",
    name: "Michael R.",
    location: "Pleasant Hill, CA",
    service: "Solar Repair",
    avatar: "https://public.readdy.ai/ai/img_res/789af69d432eb8b1cd9682e018fe1e16.jpg",
  },
  {
    quote: "Added a battery system to our existing solar. During the last grid outage, we didn't even notice. The team was seamless — one crew handled everything from assessment to activation.",
    name: "Sarah T.",
    location: "Walnut Creek, CA",
    service: "Battery Storage",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20woman%20in%20her%2040s%20smiling%20confidently%2C%20clean%20neutral%20background%2C%20natural%20lighting%2C%20approachable&width=80&height=80&seq=av-002&orientation=squarish",
  },
  {
    quote: "Panel upgrade and EV charger done in one visit. Knowledgeable, efficient, and the work quality is excellent. Clean install, no mess, everything permitted and inspected.",
    name: "David K.",
    location: "Lafayette, CA",
    service: "Electrical + EV Charger",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20man%20in%20his%2050s%20smiling%2C%20clean%20neutral%20background%2C%20natural%20lighting%2C%20confident%20trustworthy%20look&width=80&height=80&seq=av-003&orientation=squarish",
  },
  {
    quote: "Emergency electrical issue on a Sunday — responded within two hours. Fixed it fast, explained everything clearly, fair price. This is the team you want when things go wrong.",
    name: "Jennifer M.",
    location: "Concord, CA",
    service: "Emergency Electrical",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20woman%20in%20her%2030s%20smiling%2C%20clean%20neutral%20background%2C%20natural%20lighting%2C%20friendly%20approachable&width=80&height=80&seq=av-004&orientation=squarish",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-amber-500 text-xs font-bold tracking-[0.2em] uppercase">Customer Reviews</span>
            <h2
              className="text-4xl md:text-5xl font-black text-gray-950 mt-3 leading-tight tracking-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Real Results.<br />Real Customers.
            </h2>
          </div>
          <div className="flex items-center gap-3 pb-1">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(s => (
                <div key={s} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400"></i>
                </div>
              ))}
            </div>
            <span className="text-gray-500 text-sm">5.0 · 120+ verified reviews</span>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              onClick={() => setActive(i)}
              className={`rounded-2xl p-6 border cursor-pointer transition-all duration-300 flex flex-col justify-between ${
                active === i ? "bg-stone-950 border-stone-950" : "bg-stone-50 border-transparent hover:border-gray-200"
              }`}
            >
              <div>
                <div className="flex gap-0.5 mb-5">
                  {[1,2,3,4,5].map(s => (
                    <div key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                    </div>
                  ))}
                </div>
                <p className={`text-sm leading-relaxed mb-6 ${active === i ? "text-white/80" : "text-gray-600"}`}>
                  &ldquo;{t.quote}&rdquo;
                </p>
              </div>
              <div>
                <div className={`w-full h-px mb-4 ${active === i ? "bg-white/10" : "bg-gray-200"}`}></div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className={`text-sm font-bold ${active === i ? "text-white" : "text-gray-900"}`}>{t.name}</div>
                    <div className={`text-xs ${active === i ? "text-white/40" : "text-gray-400"}`}>{t.location}</div>
                  </div>
                </div>
                <div className="mt-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${active === i ? "bg-amber-500/20 text-amber-400" : "bg-amber-50 text-amber-600"}`}>
                    {t.service}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5 bg-stone-50 rounded-2xl px-8 py-6 border border-gray-100">
          <div>
            <div className="text-gray-900 font-bold text-base">Ready to get your system performing at its best?</div>
            <div className="text-gray-500 text-sm mt-0.5">Free diagnostic estimate — no obligation, no pressure.</div>
          </div>
          <button
            onClick={() => scrollTo("#contact")}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold px-7 py-3.5 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Get a Free Estimate
          </button>
        </div>
      </div>
    </section>
  );
}
